import { createSelector } from 'reselect';
import { RootState } from '@reducers';
import { SiteState } from '@reducers/sites-item';
import { SitesState } from '@reducers/sites-list';
import { SiteSelectorState } from '@reducers/sites-selector';
import { SelectedOrgSiteIdsState } from '@reducers/selected-orgId-siteId';

export const getSitesList = (store: RootState): SitesState => store.sitesList;
export const getSitesListData = createSelector(getSitesList, (sites) => sites?.data);
export const getSitesListLoading = createSelector(getSitesList, (sites) => sites?.loading);
export const getSitesListItems = createSelector(getSitesList, (sites) => sites?.data?.items);
export const getSitesListFilter = createSelector(getSitesList, (sites) => sites?.filter);

export const getSitesItem = (state: RootState): SiteState => state.sitesItem;
export const getSitesItemData = createSelector(getSitesItem, (sitesItem) => sitesItem?.data);

export const getSitesSelector = (store: RootState): SiteSelectorState => store.sitesSelector;
export const getSitesSelectorData = createSelector(getSitesSelector, (selector) => selector?.data);

export const getSelectedOrgSite = (store: RootState): SelectedOrgSiteIdsState => store.selectedOrgSite;
export const getSelectedSiteId = createSelector(getSelectedOrgSite, (item) => item?.selectedSiteId);
